import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'guid': 'String',
	'group_identifier': 'String',
	'timeslot_guid': 'String',
	'name': 'String',
	'kind': 'String',
	'date_start': 'String',
	'date_end': 'String',
	'reduce_by': 'Int',
	'increase_by': 'Int',
	'comment': 'String',
	'active': 'String!'
};

export default gql(`
	mutation timeslot_exception( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_exception( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        group_identifier
	        timeslot_id
	        name
	        kind
	        date_start
	        date_end
	        reduce_by
	        increase_by
	        comment
	        active
	    }
	}
`);

